export enum ACTION_CODES {
	APAPP = 'APPLICATION_APPROVE',
	APDEN = 'APPLICATION_DENY',
	APINC = 'APPLICATION_INCOMPLETE',
	APCAN = 'APPLICATION_CANCEL',
	APCLO = 'APPLICATION_CLOSE',
	APSPR = 'APPLICATION_SUBMITTED_PENDING_REVIEW',
	APRPS = 'APPLICATION_REOPEN_PAYMENT_STATUS',
	APRR = 'APPLICATION_REPAYMENT_REQUIRED',
	APSTC = 'APPLICATION_SEND_TO_COLLECTIONS',
	APEDP = 'APPLICATION_EDIT_EDUCATION_PROVIDER',
	APBP = 'APPLICATION_BENEFIT_PERIOD',
	APEBP = 'APPLICATION_EDIT_BENEFIT_PERIOD',
	APEPD = 'APPLICATION_EDIT_PROGRAMS_DEGREES',
	APEPF = 'APPLICATION_EDIT_PROGRAMS_FOS',
	APEC = 'APPLICATION_EDIT_COURSES',
	APEBY = 'APPLICATION_EDIT_BYPASS_REVIEWER',
	APBYA = 'APPLICATION_EDIT_BYPASS_REVIEWER_ADVANCED',
	APERD = 'APPLICATION_EDIT_REVIEW_DOCUMENTS',
	APEUD = 'APPLICATION_EDIT_UNREVIEW_DOCUMENTS',
	APDAE = 'DELETE_APPLICATION_EXCEPTION',
	APDEL = 'DELETE_APPLICATION_EXCEPTION_LIMITED',
	PYERD = 'PAYMENTS_EDIT_REFUND',
	RUDEN = 'RESOLVE_DENY_RULES',
	RUMAN = 'RESOLVE_MANUAL_RULES',
	RUINC = 'RESOLVE_INCOMPLETE_RULES',
	RUCAR = 'RESOLVE_CARRYOVER_RULES',
	APSED = 'APPLICATION_EDIT_SESSION_DATES',
	APDUP = 'APPLICATION_UPLOAD_DOCUMENTS',
	APEAA = 'APPLICATION_EDIT_APPROVED_AMOUNTS',
	APERA = 'APPLICATION_EDIT_REQUESTED_AMOUNTS',
	APEPA = 'APPLICATION_EDIT_PAYMENT_AMOUNTS',
	APVG = 'APPLICATION_VERIFY_GRADES',
	APEG = 'APPLICATION_EDIT_GRADES',
	APAE = 'APPLICATION_ADD_EXPENSE',
	DCVOD = 'DOCUMENT_VIEW_ORPHANED',
	DCVDC = 'VIEW_DOCUMENT_CONFIDENCE',
	LVRA = 'LOAN_VIEW_RECURRING_ANALYTICS',
	CLBDA = 'BETA_CLIENT_SETUP',
	CLBDR = 'BETA_CLIENT_SETUP_READONLY',
	CLSET = 'CLIENT_SETUP',
	CLPRG = 'PROGRAM_DASHBOARD',
	CLACP = 'ADD_CLIENT_PROGRAM',
	CRPPT = 'ADD_CLIENT_PARTICIPANT',
	CRAPP = 'PARTICIPANT_CREATE_APPLICATION',
	CLCGD = 'ADD_CAREER_PATHWAY_GLOBAL_DATA',
	CLCCD = 'ADD_CAREER_PATHWAY_CLIENT_DATA',
	PYSET = 'PAYMENTS_SETUP',
	PYCFE = 'PAYMENTS_CONFIG',
	PYCFR = 'PAYMENTS_CONFIG_READ_ONLY',
	PYSRD = 'PAYMENTS_DASHBOARD_READ_ONLY',
	FTPAY = 'SUBMIT_FAST_TRACK_PAYMENT',
	DCDAD = 'DELETE_APPLICATION_DOCUMENT',
	APEDT = 'EDIT_DOCUMENT_TYPE',
	APEAS = 'APPLICATION_ADD_SAVINGS',
	APELS = 'APPLICATION_LIMITIED_SAVINGS',
	APEDS = 'APPLICATION_DELETE_SAVINGS',
	APERP = 'APPLICATION_EDIT_REPAYMENTAMOUNT_OWED',
	TSKVW = 'VIEW_TASK_PAGE',
	WFVW = 'VIEW_WORKFLOW_PAGE',
	APEAC = 'APPLICATION_ADD_COURSE',
	PMTVW = 'VIEW_PAYMENT_PAGE',
	APEPP = 'APPLICATION_EDIT_PERCENT_PAYOUT',
	PAEPA = 'EDIT_PARTICIPANT_ALERTS',
	PAELA = 'EDIT_LIMITED_ALERT',
	APPC = 'OPEN_FOR_DOCUMENTS',
	ADMTL = 'ADMIN_TOOLS',
	ADTLR = 'ADMIN_TOOLS_READ_ONLY',
	APESA = 'SUBMIT_APPLICATION',
	PAAPA = 'ADD_PARTICIPANT_ALERT',
	APETQ = 'ADD_COURSE_WITH_TAX_QUESTIONS',
	APVCA = 'VIEW_VIRTUAL_CARD_AMOUNTS',
	APLSD = 'APPLICATION_LIMITED_EDIT_SESSION_DATES',
	WFRO = 'WORKFLOW_PAGE_READ_ONLY',
	CLIRU = 'RULE_NAMES_SETUP',
	CLPRO = 'PROVIDER_SETUP',
	LAIEP = 'ENABLE_EDIT_LOAN_INFO',
	PYSAD = 'PAYMENT_SOLUTION_DASHBOARD_AUDIT',
	LAEPE = 'ENABLE_EDIT_EDUCATION_PROGRAM_INFO',
	ADFRQ = 'EDIT_LOAN_APP_INFORMATION_FREQUENCY',
	PAEAD = 'EDIT_PARTICIPANT_ADDRESS',
	APESP = 'STOP_PAYMENT',
	PARER = 'EDIT_REVIEWER',
	EPEPA = 'EDIT_EDUCATIONAL_PROVIDER_ACCREDITATIONS',
	EPAPA = 'ADD_EDUCATIONAL_PROVIDER_ACCREDITATIONS',
	EPEPN = 'EDIT_EDUCATIONAL_PROVIDER_NETWORK',
	EPEPD = 'EDIT_EDUCATIONAL_PROVIDER_DETAIL',
	EPDOC = 'EDIT_EDUCATIONAL_PROVIDER_DOCUMENT',
	EPETP = 'EDIT_EDUCATIONAL_PROVIDER_TAILORED_PROGRAMS',
	EPAPD = 'ADD_EDUCATIONAL_PROVIDER',
	EPAPP = 'ADD_EDUCATIONAL_PROGRAM_PROVIDER',
	EPDPP = 'DELETE_EDUCATIONAL_PROGRAM_PROVIDER',
	EPEPP = 'EDIT_EDUCATIONAL_PROGRAM_PROVIDER'
}
